import React from 'react';
import { ParameterType, Type } from '../apiref/apireftypes';
import { ApiRef } from '../fasades/apiref';

export function createResponse() : ParameterType
{
    const desc = (<>
        </>);

    return {
        id          : "Response",
        name        : "Response",
        description : desc,
        type        : Type.Object,
        parameters  : [
            {
                "name"        : "reward",
                "type"        : "number",
                "description" : <>
                    <p>The reward value indicating how desirable this response is. The training system uses the GRPO (Group Relative Policy Optimization) algorithm to calculate advantage from your reward values.</p>
                    <p><strong>The key insight is that it's the relative reward that matters, not the absolute values.</strong> When you provide multiple responses with different reward values, the system:</p>
                    <ol>
                        <li>Calculates the mean and standard deviation of all rewards in the group</li>
                        <li>Normalizes each reward to compute the advantage: <pre><code>advantage = (reward - mean) / standard_deviation</code></pre></li>
                        <li>Uses this advantage value to guide the model's weight updates during training</li>
                    </ol>
                    <p>The rewards are normalized to ensure that responses with above-average rewards get positive advantages (encouraging the model to favor them), while responses with below-average rewards get negative advantages (discouraging those patterns).</p>
                    <p><strong>Important:</strong> All rewards must not be identical - the system requires variation in reward values to calculate meaningful advantages. If all responses have the same reward, training cannot proceed as there would be no relative preference to learn from.</p>
                </>,
                "optional"    : false
            },
            {
                "name"        : "response",
                "type"        : "string",
                "description" : <p>The text response content that the model should learn to produce 
                                   (or avoid if advantage is negative). This is the actual text that
                                   represents the desired or undesired response pattern.</p>,
                "optional"    : false
            }
        ]
    };
}

export function createResponses() : ParameterType
{
    const childType = ApiRef.getType("Response");

    const desc = (<>
        <h3>Response Array</h3>
        <p>Contains a array of different possible response, each Response contain a response(text) and a reward.</p>
        <p>The rewards are normalized to ensures that responses with above-average rewards 
           get positive advantages (encouraging the model to favor them), while responses
           with below-average rewards get negative advantages (discouraging those patterns).</p>
        { childType.description }
        </>);

    return {
        id          : "Response[]",
        name        : "Responses",
        description : desc,
        type        : Type.Array,
        childType   : childType
    };
}

